<template>
  <div>
    <el-dialog
      :title="dialogTitle"
      :visible="dialog"
      width="50%"
      top="3vh"
      :modal="true"
      :append-to-body="true"
      @close="close"
      @open="open"
    >
      <el-form :model="form_opportunity" label-position="top">
        <el-form-item label="Title" prop="title">
          <el-input type="text" v-model="form_opportunity.title" clearable />
        </el-form-item>
        <el-form-item label="Description" prop="quote">
          <el-input type="textarea" v-model="form_opportunity.quote" clearable />
        </el-form-item>
        <el-form-item label="Link" prop="post_link">
          <el-input type="text" v-model="form_opportunity.post_link" clearable />
        </el-form-item>
        <el-form-item label="Position" prop="position">
          <el-input type="number" v-model="form_opportunity.position" clearable />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button
          type="primary"
          size="mini"
          :loading="loading"
          @click="submit()"
        >
          Save
        </el-button>
      </div>
    </el-dialog>
    <Preview :previewText="text" />
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { VueEditor } from 'vue2-editor'
import Preview from '@/global/components/Preview'

export default {
  components: {
    VueEditor,
    Preview
  },

  data() {
    return {
      text: '',
      fileList: [],
      url: process.env.VUE_APP_ADMIN_API_URL,
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
      image: { name: '', url: '' },
      labelNameArtist: 'artist',
      form_opportunity: {
        id: null,
        title: null,
        quote: null,
        post_link: null,
        position: null
      }
    }
  },

  computed: {
    dialogTitle: function() {
      if (
        typeof this.opportunity.id !== 'undefined' &&
        this.opportunity.id !== null
      ) {
        return 'Edit Opportunity'
      } else {
        return 'Insert Opportunity'
      }
    },
    ...mapState('opportunityCarousel', [
      'loading',
      'opportunity',
      'dialog',
      'artists'
    ])
  },

  methods: {
    ...mapActions('opportunityCarousel', ['update', 'insert']),
    ...mapMutations('opportunityCarousel', ['setDialog']),
    ...mapMutations('global', ['setPreview']),

    submit() {
      this.opportunity.id = this.form_opportunity.id
      this.opportunity.title = this.form_opportunity.title
      this.opportunity.quote = this.form_opportunity.quote
      this.opportunity.post_link = this.form_opportunity.post_link
      this.opportunity.position = this.form_opportunity.position
      this.clearForm()
      if (
        typeof this.opportunity.id !== 'undefined' &&
        this.opportunity.id !== null
      )
        this.update(this.opportunity.id)
      else {
        this.insert()
      }
    },

    onSuccess(response, file) {
      this.form_opportunity.image_url = response.response.message
      this.$message({
        type: 'success',
        message: `File ${file.name} uploaded`
      })
    },

    onError(err) {
      var res = JSON.parse(err.message)
      this.$message({
        type: 'error',
        message: res ? res.response.message : 'Upload error!'
      })
    },

    onRemove() {
      this.form_opportunity.image_url = null
    },

    onExceed() {
      this.$message({
        type: 'error',
        message: 'Only one image can be uploaded'
      })
    },

    open() {
      console.log(this.opportunity)
      if (
        typeof this.opportunity.id !== 'undefined' &&
        this.opportunity.id !== null
      ) {
        this.form_opportunity.id = this.opportunity.id
        this.form_opportunity.title = this.opportunity.title
        this.form_opportunity.quote = this.opportunity.quote
        this.form_opportunity.post_link = this.opportunity.post_link
        this.form_opportunity.position = this.opportunity.position
      }
    },

    openPreview(sometext) {
      this.setPreview(true)
      this.text = sometext
    },

    clearForm() {
      this.form_opportunity.id = null
      this.form_opportunity.title = null
      this.form_opportunity.quote = null
      this.form_opportunity.post_link = null
      this.form_opportunity.position = null
    },

    close() {
      this.clearForm()
      this.setDialog(false)
    }
  }
}
</script>

<style lang="scss" scoped>
.inline-eye {
  display: inline-block;
}
</style>
